import type { TranslationF } from "@/utils/type-utils";
import { z } from "zod";

const portSchema = z.preprocess((val) => {
	if (typeof val === "string") {
		const trimmed = val.trim();
		if (trimmed === "") return undefined;
		const n = Number(trimmed);
		return Number.isNaN(n) ? val : n;
	}
	return val;
}, z.number().int().min(1).max(65535));

export const getProxySchema = (t: TranslationF) =>
	z.object({
		ip_address: z.string().url(t("validation.urlWithProtocol")),
		port: portSchema,
		username: z
			.preprocess((v) => (v === "" ? null : v), z.string().nullable())
			.optional()
			.default(null),
		password: z
			.preprocess((v) => (v === "" ? null : v), z.string().nullable())
			.optional()
			.default(null),
	});

export type ProxyFormData = z.infer<ReturnType<typeof getProxySchema>>;

export type ProxyInitialValues = {
	ip_address: string;
	port?: number;
	username: string | null;
	password: string | null;
};
